import { render, staticRenderFns } from "./SelectBack3.vue?vue&type=template&id=189d01f8&"
import script from "./SelectBack3.vue?vue&type=script&lang=js&"
export * from "./SelectBack3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports